<template lang="html">
  <div class="container">
<HomeHeader position="bottom"></HomeHeader>

    <div class="wrap">
      <div class="btn-wrap">
        <span class="btn-logo"></span>
        <span class="btn-download" @click="goDownload()"></span>
      </div>
      </div>
          <onlinePlay />
  </div>
</template>

<script>
  import API from "../api/api";
  import utils from "../api/utils";
  import addClientEvent from "../api/addClientEvent";
  import 'swiper/dist/css/swiper.css'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import HomeHeader from "./homeCompents/homeHeader";

  import onlinePlay from "./homeCompents/onlinePlay";
  import { mapState, mapMutations } from 'vuex';
  import $ from 'jquery';
  export default {
    name: "home",
    components: {
      HomeHeader,
      onlinePlay,
      swiper,
      swiperSlide
    },
    data() {
      const that_obj = this;
      return {
        showIndex: 0,
        scroller: '',
        tabIndex: 2,
        scrollerTop: 0,
        showImgModalBool:false,
        showList: [],
        currentImgIndex : 0,
        imageLength : 0,
        swiperOption: {
          zoom: true,
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swiper
          grabCursor:true,
          centeredSlides:true,
          on:{
            slideChangeTransitionStart: function() {
              that_obj.currentImgIndex = this.realIndex + 1
            }
          }
        },
        slideHeight:window.screen.height - 104,
        screenHeight: document.documentElement.clientHeight,
        channel: '',
        isHide: '',
        tabItem: ["在线玩", "轻资讯"],
        loadingImg:require('../assets/loading.gif'),

      };
    },
    watch: {
      tabIndex () {
        $('.top-tabs li').eq(this.tabIndex).addClass('active').siblings().removeClass('active')
        $('.top-swiper .menuTab').eq(this.tabIndex).addClass('active').siblings().removeClass('active')
        if (this.tabIndex == 0) {
          this.scroller = this.homeScroller
           let recordData = {
            "eventType": 'h5_homepage_1',
            "pageName": '首页',
            "rese8": '点击 首页-在线玩',
          }
          addClientEvent.recordEventAction(recordData)
        } else {
          this.scroller = this.newsScroller
           let recordData = {
            "eventType": 'h5_homepage_2',
            "pageName": '首页',
            "rese8": '点击 首页-轻资讯',
          }
          addClientEvent.recordEventAction(recordData)
        }
      }
    },
    computed: {
      tabSwiper () {
        return this.$refs.tabSwiper.swiper
      }
     
    },
    created () {
      this.channel = MG.utils.getQueryString('channel') ? MG.utils.getQueryString('channel') : ''
      this.isHide = MG.utils.getQueryString('isHide') ? MG.utils.getQueryString('isHide') : ''
    },
    mounted () {
      
      this.tabIndex = 0

      document.title = "咪咕快游 - 快乐一点就来";
     
    },
    beforeRouteEnter(to,from,next) {
      if (!sessionStorage.tabIndex || from.path == '/') { //当前页面刷新不需要切换位置
        next();
      } else {
        next(vm => {
          if(sessionStorage.tabIndex) {
            vm.tabIndex = sessionStorage.tabIndex
            if (sessionStorage.showIndex) {
              vm.showIndex = sessionStorage.showIndex
            }
            document.title = "咪咕快游-快乐一点就来";
            setTimeout(function () {
                window.location.reload();
             // vm.scroller.scrollTo(0, parseInt(sessionStorage.position), false);
            }, 10) 
          }
        })
      }
   },
   beforeRouteLeave (to,from,next) { //记录离开时的位置
      sessionStorage.tabIndex = this.tabIndex
      sessionStorage.position = this.scroller && this.scroller.getPosition() && this.scroller.getPosition().top
      next();
   },
   methods: {
      getPicThumb(pic_url){
        var path_arr = pic_url.split('.');
        var ret_str = '';
        for(var i=0;i<path_arr.length-1;i++){
          ret_str += path_arr[i] + '.';
        }

        ret_str = ret_str.substring(0,ret_str.length-1);

        if(path_arr[path_arr.length-1].toLowerCase() == 'gif'){
          ret_str += '_coverpic.';
        }else{
          ret_str += '_sdpic.';
        }
        ret_str += path_arr[path_arr.length-1];

        return ret_str;
        return {
          src:ret_str,
          loading:'http://www.sucaijishi.com/uploadfile/2013/0527/20130527034917708.gif'
        };
        return "background:url(" + ret_str + ") no-repeat center;background-size: cover;";
      },
      hideModel(){
        this.showList = [];
        this.showImgModalBool=false;
      },
      getBgHeight(){
        return "line-height:" + this.screenHeight + "px;";
      },
      getPicStyle(resolution){
        var screenWidth = document.body.clientWidth
        var screenHeight = document.body.clientHeight
        var imgWidth = resolution.split("*")[0] * 1
        var imgHeight = resolution.split("*")[1] * 1
        var ret_str = "";
        ret_str += "width:"+screenWidth+"px;";
        return ret_str;
      },
      showOuterModel(arr,index){
        this.currentImgIndex = index + 1;
        this.imageLength = arr.length;
        console.log(index)
        this.showList = arr;
        this.$refs.imgSwiper.swiper.slideTo(index,0,false);
        this.showImgModalBool = true
        /*setTimeout(e => {
          this.$refs.imgSwiper.swiper.slideTo(index,0,false);
  　　　 }, 30);*/
      },
      getScroller (type, scroller) {
        if (type == 'home') {
          this.homeScroller = scroller
        } else {
          this.newsScroller = scroller
        }
      },
      countHeaderBarPos () {
        let inter = setInterval(e => {
          let top = this.scroller && this.scroller.getPosition() && this.scroller.getPosition().top
          if (top) {
            if (top > 0) {
              // console.log('1 this.scrollerTop', this.scrollerTop)
              // console.log('2 top', top)
              if (top != this.scrollerTop) {
                $('.btn-wrap').css('top', this.getPxToRem(-top))
                $('.top-tabs').css('top', top < 60 ? this.getPxToRem(60 - top) : 0)
                $('.top-swiper').css('top', top < 60 ? this.getPxToRem(104 - top) : this.getPxToRem(44))
                $('.top-swiper').css('height', top < 60 ? this.getPxToRem2(window.screen.height - 104 + top) : this.getPxToRem2(window.screen.height - 44))
                this.scrollerTop = top
              } else {
                clearInterval(inter)
              }
            } else {
              $('.btn-wrap').css('top', 0)
              $('.top-tabs').css('top', this.getPxToRem(58))
              $('.top-swiper').css('top', this.getPxToRem(104))
              $('.top-swiper').css('height', this.getPxToRem2(window.screen.height - 104))
              clearInterval(inter)
            }
          }
        }, 50)
      },
      getPxToRem (length) {
        return length / 37.5 + 'rem'
      },
      getPxToRem2 (length) {
        return length / window.screen.width * 10 + 'rem'
      },
      goSearch () {
        _hmt.push(['_trackEvent', '首页', '点击搜索图标', this.channel])
        let recordData = {
          "eventType": 'h5_homepage_4',
          "pageName": '首页',
          "rese8": '点击 首页-搜索',
        }
        addClientEvent.recordEventAction(recordData)

        let queryParam = this.channel ? {channel: this.channel} : {}
        if (this.isHide) queryParam['isHide'] = this.isHide
        this.$router.push({
          name: 'search',
          query: queryParam
        })
      },
      changeSlideTop(index) {
        setTimeout(e => {
          this.tabIndex = index
        }, 10)
       
      },
      getShareInfo () {
        //分享内容
        let share = new MG.Share({
          url: window.location.href,
          title: '咪咕快游',
          content: '快乐一点就来',
          image: 'http://www.migufun.com/miguplay/static/image/migu-share.jpg',
          friend: '咪咕快游' + " | " + '快乐一点就来'
        });
      },
      goDownload () {
        _hmt.push(['_trackEvent', '首页', '点击顶部下载图标', this.channel])
        let recordData = {
          "eventType": 'h5_homepage_3',
          "pageName": '首页',
          "rese8": '点击 首页-下载',
        }
        addClientEvent.recordEventAction(recordData)
        utils.pullGame()
      }
    }
  };

</script>

<style lang='scss' rel='stylesheet/scss' scoped>
  @import './../assets/miguplay/css/home.scss';

  html, body, #app {
    background: #fff;
  
  }
  .container {
    padding:2rem 0;
  }
  .top-swiper {
    width: 100%;
  }
  .menuTab {
    width: 100%;
    height: 100%;
    visibility: hidden;
  }
  .menuTab.active {
    visibility: visible;
  }

  .popup-div{
    position: fixed;
    background:rgba(0,0,0,0.9);
    left:0;
    bottom: 0;
    width:100%;
    height: 100%;
    z-index:999999;
    text-align: center;
    vertical-align: middle;
    /*overflow: hidden;*/
  }
  body.fixation  { height:100%;overflow:hidden; }
  .popup-div div.bg {
    margin-left:0px;width:100%;
    height: 100%;
    /*user-select: none;
    -webkit-user-select: none;*/
    -webkit-tap-highlight-color: transparent; 
  }
  .popup-div div.bg  .swiper-container{
    width:100%;
    height: 100%;
    overflow-x:hidden;
    overflow-y:auto;
    -webkit-overflow-scrolling:touch;
    /*user-select: none;
    -webkit-user-select: none; */
    -webkit-tap-highlight-color:transparent; 
  }
 .outering_div{
    width: 100%;
    height: 100%;
    /*user-select: none;
    -webkit-user-select: none; */
    -webkit-tap-highlight-color: transparent;
  }

  .popup-div div.bg img,.popup-div div.bg video {max-width: 100%;vertical-align: middle;}
  .popup-div div.bg video{
    max-height:80%;
  }

  div.bg i.close {display:block;background: url(../assets/light_news/icon_topic_close.png)no-repeat center/cover;height: 20rem/$basic;width: 20rem/$basic;position: fixed;z-index: 99;left: 15rem/$basic;
    top: 30rem/$basic;
  }
  div.bg span.num {width: 30rem/$basic;height: 15rem/$basic;display: block;position:fixed;top: 30rem/$basic;right: 15rem/$basic;color: #fff;font-size: 14rem/$basic;z-index: 99;line-height: 15rem/$basic;}
  div.bg span.down {display:block;}
</style>


// WEBPACK FOOTER //
// src/components/home.vue